import { useMemo } from 'react';
import { Tag } from 'antd';
import {
  FaPlus,
  FaPhone,
  FaClock,
  FaHome,
  FaCheckCircle,
  FaTimesCircle,
  FaStop,
  FaMeh,
  FaExclamationTriangle,
  FaQuestionCircle,
  FaTimes,
} from 'react-icons/fa';

export const useStatusRender = () => {
  return useMemo(
    () => (status: string) => {
      const statusConfigs: Record<
        string,
        {
          text: string;
          icon: React.ReactNode;
          bgColor: string;
          textColor: string;
          borderColor: string;
        }
      > = {
        NEW: {
          text: 'New',
          icon: <FaPlus />,
          bgColor: '#e6f7ff',
          textColor: '#1890ff',
          borderColor: '#91d5ff',
        },
        CONTACTED: {
          text: 'Contacted',
          icon: <FaPhone />,
          bgColor: '#fff7e6',
          textColor: '#fa8c16',
          borderColor: '#ffd591',
        },
        FOLLOW_UP: {
          text: 'Follow-Up',
          icon: <FaClock />,
          bgColor: '#f0f5ff',
          textColor: '#2f54eb',
          borderColor: '#adc6ff',
        },
        CLINIC_VISITED: {
          text: 'Clinic Visited',
          icon: <FaHome />,
          bgColor: '#f9f0ff',
          textColor: '#722ed1',
          borderColor: '#d3adf7',
        },
        CONVERTED: {
          text: 'Converted',
          icon: <FaCheckCircle />,
          bgColor: '#f6ffed',
          textColor: '#52c41a',
          borderColor: '#b7eb8f',
        },
        NOT_CONVERTED: {
          text: 'Not Converted',
          icon: <FaTimes />,
          bgColor: '#fff1f0',
          textColor: '#cf1322',
          borderColor: '#ffa39e',
        },
        NOT_INTERESTED: {
          text: 'Not Interested',
          icon: <FaTimesCircle />,
          bgColor: '#fff2f0',
          textColor: '#ff4d4f',
          borderColor: '#ffccc7',
        },
        NO_RESPONSE: {
          text: 'No Response',
          icon: <FaMeh />,
          bgColor: '#fafafa',
          textColor: '#8c8c8c',
          borderColor: '#d9d9d9',
        },
        INVALID: {
          text: 'Invalid',
          icon: <FaStop />,
          bgColor: '#fff0f6',
          textColor: '#eb2f96',
          borderColor: '#ffadd2',
        },
        LOST: {
          text: 'Lost',
          icon: <FaExclamationTriangle />,
          bgColor: '#fff1f0',
          textColor: '#cf1322',
          borderColor: '#ffa39e',
        },
      };

      const config = statusConfigs[status] || {
        text: status || 'Unknown',
        icon: <FaQuestionCircle />,
        bgColor: '#f5f5f5',
        textColor: '#8c8c8c',
        borderColor: '#d9d9d9',
      };

      return (
        <Tag
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            fontWeight: 500,
            padding: '4px 8px',
            borderRadius: '6px',
            lineHeight: '1.2',
            backgroundColor: config.bgColor,
            color: config.textColor,
            border: `1px solid ${config.borderColor}`,
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center' }}>
            {config.icon}
          </span>
          <span>{config.text}</span>
        </Tag>
      );
    },
    []
  );
};
